import { c as _c } from "react/compiler-runtime";
import type { DefinitionListItem } from '@newfront-insurance/core-ui';
import { DefinitionList } from '@newfront-insurance/core-ui';
import { DateFormatStyle } from '@newfront-insurance/string-formatters';
import type { MouseEvent, JSX } from 'react';
import { stringifyLinesOfCoverage } from './utils';
import type { Policy } from '../../../../../../bff/types';
interface Props {
  policy: Policy;
  onAccountClick: (e: MouseEvent) => void;
}
export function PolicyDefinitionList(props) {
  const $ = _c(5);
  const {
    policy,
    onAccountClick
  } = props;
  let t0;
  if ($[0] !== onAccountClick || $[1] !== policy) {
    t0 = createPolicyDefinitionList({
      policy,
      onAccountClick
    });
    $[0] = onAccountClick;
    $[1] = policy;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <DefinitionList items={t0} labelWidth="150px" />;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function createPolicyDefinitionList(props: Props): DefinitionListItem[] {
  const {
    policy,
    onAccountClick
  } = props;
  const {
    account,
    expirationDate,
    linesOfCoverage,
    effectiveDate,
    policyNumber,
    carrier
  } = policy;
  let items: DefinitionListItem[] = [];
  if (account) {
    items.push({
      type: 'name',
      title: 'Client',
      value: account?.name || '-',
      href: `/accounts/${policy.accountUuid}`,
      onClick: onAccountClick
    });
  }
  items = [...items, {
    type: 'document',
    title: 'Line of coverage',
    value: stringifyLinesOfCoverage(linesOfCoverage)
  }, {
    type: 'dateRange',
    title: 'Effective dates',
    value: `${effectiveDate.format({
      style: DateFormatStyle.STANDARD
    })} - ${expirationDate.format({
      style: DateFormatStyle.STANDARD
    })}`
  }, {
    type: 'business',
    title: 'Carrier',
    value: carrier?.name || '-'
  }];
  if (policyNumber) {
    items.push({
      type: 'number',
      title: 'Policy number',
      value: policyNumber,
      target: '_blank'
    });
  }
  return items;
}